import React from 'react';
import { ErrorMessage } from './error-message';
export const Select = React.forwardRef(({ error, value, options, placeholder, ...props }, ref) => {
    const style = !value ? { color: 'rgba(96, 108, 124, 0.6)' } : {};
    return (<>
      <select className={`form-field__select ${error && 'form-control--error'}`} ref={ref} style={style} {...props}>
        {placeholder && <option value="" disabled hidden={!!value}>{placeholder}</option>}
        {options.map(({ label, value }) => (<option key={value.toString()} value={value}>{label}</option>))}
      </select>
      <ErrorMessage error={error}></ErrorMessage>
    </>);
});
